import axios, { AxiosResponse, AxiosError } from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const getServices = (
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
  };
  axios
    .get(`${global.api_url}/api/services`, {
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      } else {
        _errorCallBack("Unexpected status code: " + response.status);
      }
    })
    .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 404) {
            console.log(error.response.data);
          _errorCallBack(error.response.data);
        }else if (error.response?.status === 401) {
          localStorage.clear();
        } 
      });
};

export const addServices = (
  type: string | null,                             
  model: string | null,                            
  selling_price: string | null, 
  platform_model:string|null,                                         
  _successCallBack: (response: any) => void,       
  _errorCallBack: (errMessage: any) => void        
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`,
    'Content-Type': 'multipart/form-data',        
  };
  const formData = new FormData();
  formData.append('type', type!);
  formData.append('model', model!);
  formData.append('selling_price', selling_price!);
  formData.append('platform_model', platform_model!);
  
  axios
    .post(`${global.api_url}/api/services`, formData, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data); 
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data); 
      }else  if (error.response?.status === 500) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 401) {
        localStorage.clear(); 
      } else {
        toast.error('Server Error'); 
      }
    });
};
export const getDevicesSim = (
    serviceId: string,
    status: string | '',
    list_devices: number | undefined,
    list_sims: number | undefined,
    per_page_records: number,
    page_number: number,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
        Authorization: `Bearer ${userDetailsFromStorage?.token}`, 
    };
    let url = `${global.api_url}/api/devices_sims?services_id=${serviceId}&per_page_records=${per_page_records}&page_number=${page_number}&status=${status}`;
    if (list_devices !== undefined) {
        url += `&list_devices=${list_devices}`;
    }
    if (list_sims !== undefined) {
        url += `&list_sims=${list_sims}`;
    }

    axios
    .get(url, {
        headers: headers,
    })
    .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
            _successCallBack(response.data);
        } else {
            _errorCallBack("Unexpected status code: " + response.status);
        }
    })
    .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
        } else if (error.response?.status === 404) {
            console.log(error.response.data);
            _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
            localStorage.clear();
        } 
    });
};
export const bulkUploadDevices = (
  upload_type: 'device' | 'sim', 
  file: File, 
  service: string | number | null, 
  service_provider: string | null,                                        
  _successCallBack: (response: any) => void,       
  _errorCallBack: (errMessage: any) => void        
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    'Content-Type': 'multipart/form-data',        
  };
  
  const formData = new FormData();
  formData.append('upload_type', upload_type);
  formData.append('file', file);
  if (upload_type === 'device' && service) {
    formData.append('service', service.toString());
  }
  
  if (upload_type === 'sim' && service_provider) {
    formData.append('service_provider', service_provider);
  }
  
  axios
    .post(`${global.api_url}/api/bulk_upload_devices`, formData, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data); 
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400 || error.response?.status === 409) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 500) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 401) {
        localStorage.clear(); 
      } else {
        toast.error('Server Error'); 
      }
    });
};
export const getVehicle = (
    with_devices:any,
  per_page_records:any,
  page_number:any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
  companies_id?: string,
  device_status?:string,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/vehicles`, {
        params :{ with_devices,per_page_records, page_number, companies_id,device_status }, 
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if( error.response?.status === 404)
        {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
  };
   export const getCompanies = (
    per_page_records:any,
    page_number:any,
    companies_id: string | null, 
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    ) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`, 
    };
    axios
      .get(`${global.api_url}/api/companies`, {
        params: {per_page_records, page_number,companies_id }, 
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack(response.data);
        } else {
          _errorCallBack("Unexpected status code: " + response.status);
        }
      })
      .catch((error: AxiosError) => {
          console.log('Error caught:', error);
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          } else if (error.response?.status === 404) {
              console.log(error.response.data);
            _errorCallBack(error.response.data);
          }else if (error.response?.status === 401) {
            localStorage.clear();
          } 
        });
  };
export const addDeployment = (
  device_id: number,
  sim_id: number,
  vehicles_id: number,
  services_id: number,
  remarks: string,
  deployment_assigned_users_id: string,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`
  };

  axios.put(
    `${global.api_url}/api/vehicles_devices/${vehicles_id}?services_id=${services_id}&device_status=active&remarks=${remarks}&deployment_assigned_users_id=${deployment_assigned_users_id}&device_id=${device_id}&sim_id=${sim_id}`, 
    {},
    { headers: headers }
  )
    .then((response: AxiosResponse) => {
      _successCallBack(response.data);
    })
    .catch((error: AxiosError) => {
      console.log('Error caught:', error);
      if (error.response?.status === 400 || error.response?.status === 404) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else {
        toast.error("Server Error");
        console.log("Server Error", error);
      }
    });
};
export const addPhotos = (
  number_plate:string,
  vehicle_number_plate_pic: File | null,
  deployed_device_pic: File | null,                                   
  _successCallBack: (response: any) => void,       
  _errorCallBack: (errMessage: any) => void        
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`,
    'Content-Type': 'multipart/form-data',        
  };
  const formData = new FormData();
  formData.append('number_plate', number_plate);
  formData.append('vehicle_number_plate_pic', vehicle_number_plate_pic!);
  formData.append('deployed_device_pic', deployed_device_pic!);
  
  axios
    .post(`${global.api_url}/api/vehicles/${number_plate}/photos`, formData, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data); 
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data); 
      }else  if (error.response?.status === 500) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 401) {
        localStorage.clear(); 
      } else {
        toast.error('Server Error'); 
      }
    });
};

export const deleteDevicesSim = (
  devices_id: number,
  sim_id: number, 
  sim_status:string,             
  _successCallBack: (response: any) => void,    
  _errorCallBack: (errMessage: any) => void,     
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`,           
    'Content-Type': 'application/json',         
  };
  axios
    .delete(`${global.api_url}/api/devices_sims?device_id=${devices_id}&sim_id=${sim_id}&sim_status=${sim_status}`, {
      
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        _successCallBack(response.data);         
      }
      else if(response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);     
      }else if (error.response?.status === 404) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();                  
      } else {
        toast.error('Server Error');             
      }
    });
};

export const getModels = (
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`, 
  };
  axios
    .get(`${global.api_url}/api/list_models`, {
      headers: headers,
    })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      } else {
        _errorCallBack("Unexpected status code: " + response.status);
      }
    })
    .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 404) {
            console.log(error.response.data);
          _errorCallBack(error.response.data);
        }else if (error.response?.status === 401) {
          localStorage.clear();
        } 
      });
};
export const editServices = (
 services_id: string | number,
 model: string | null,
 type: string | null,
 selling_price: string | null,
 platform_model:string|null,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`
  };

  axios.put(
    `${global.api_url}/api/services/${services_id}?model=${model}&type=${type}&selling_price=${selling_price}&platform_model=${platform_model}`, 
    {},
    { headers: headers }
  )
    .then((response: AxiosResponse) => {
      _successCallBack(response.data);
    })
    .catch((error: AxiosError) => {
      console.log('Error caught:', error);
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else {
        toast.error("Server Error");
      }
    });
};
export const editDevicesSim = (
  type: string,
  payload: any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`
  };

  const queryParams = {
    type: type,
    ...payload
  };

  axios.put(
    `${global.api_url}/api/devices_sims`, 
    {},
    { 
      headers: headers,
      params: queryParams,
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        for (const key in params) {
          if (Array.isArray(params[key])) {
            params[key].forEach((val: any) => searchParams.append(`${key}[]`, val));
          } else if (params[key] !== undefined && params[key] !== null) {
            searchParams.append(key, params[key]);
          }
        }
        return searchParams.toString();
      }
    }
  )
    .then((response: AxiosResponse) => {
      _successCallBack(response.data);
    })
    .catch((error: AxiosError) => {
      console.log('Error caught:', error);
      if (error.response?.status === 400 || error.response?.status === 404) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else {
        toast.error("Server Error");
      }
    });
};
export const editVehicle = (
  number_plate:string,
  device_deployment_date:string,
  device_status:string,
  deployed_users_id:string,
  companies_id:string,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void
  ) => {
const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const encodedNumberPlate = encodeURIComponent(number_plate);
  const payload = {
    device_deployment_date,
    device_status,
    deployed_users_id,
    companies_id
  };
    axios.put(`${global.api_url}/api/vehicles/${encodedNumberPlate}`, payload, {
      headers: {
        'Authorization': `Bearer ${userDetailsFromStorage.token}`,
      },
    })
      .then((response: AxiosResponse) => {
        if(response.status === 201) {
        _successCallBack(response.data);
      }
        else if(response.status === 200) 
      { _successCallBack(response.data);
      }
    })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          console.log(error);
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
          localStorage.clear();
          toast.error("Login Expired")
        } else if (error.response?.status === 500){
          toast.error(error?.response?.message);
        }
        else if( error.response?.status === 404)
          {
            _errorCallBack(error.response.data);
          }else {
            console.log(payload);
            console.log(error);
          toast.error("Server Error1");
        }
      });
  };
 export const searchDevicesSim = (
    devices: string,
    sim: string,
    list_devices: number | undefined,
    list_sims: number | undefined,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
        Authorization: `Bearer ${userDetailsFromStorage?.token}`, 
    };
    
    let url = `${global.api_url}/api/search_devices_sims?device_search=${devices}&sim_search=${sim}`;
    if (list_devices !== undefined) {
        url += `&list_devices=${list_devices}`;
    }
    if (list_sims !== undefined) {
        url += `&list_sims=${list_sims}`;
    }

    axios
    .get(url, { headers: headers })
    .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
            _successCallBack(response.data);
        } else {
            _errorCallBack("Unexpected status code: " + response.status);
        }
    })
    .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
        } else if (error.response?.status === 404) {
            console.log(error.response.data);
            _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
            localStorage.clear();
        } 
    });
};
export const getAssignedUsers = (
device_id:string,
user_phone:string,
role_name:string,
country_code:string,
companies_id:string,
per_page_records:number,
page_number:number,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,

  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/users/?device_id=${device_id}&user_phone=${user_phone}&country_code=${country_code}&companies_id=&per_page_records=${per_page_records}&page_number=0&user_name=&role_name=platform`, { 
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if( error.response?.status === 404)
        {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
  };
  export const addDeviceSimPairing = (
  device_id: string | number,
  sim_id: string | number,                                         
  _successCallBack: (response: any) => void,       
  _errorCallBack: (errMessage: any) => void        
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const headers = {
    Authorization: `Bearer ${userDetailsFromStorage.token}`,
    'Content-Type': 'multipart/form-data',        
  };
  const formData = new FormData();
  formData.append('device_id', device_id.toString());
  formData.append('sim_id', sim_id.toString());
  
  axios
    .post(`${global.api_url}/api/devices_sims/pair`, formData, { headers })
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data); 
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data); 
      }else  if (error.response?.status === 500) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 404) {
        _errorCallBack(error.response.data); 
      } else if (error.response?.status === 401) {
        localStorage.clear(); 
      } else {
        toast.error('Server Error'); 
        console.log('Server Error', error);
      }
    });
};